import { useState } from 'react';
import { Link } from 'react-router-dom';
import logoPrimary from '../../assets/images/logo-primary.png';
import logoHorizontal from '../../assets/images/logo-horizontal.png';
import { esqueciSenha } from '../../api/auth';
import { extrairMensagemErro } from '../../components/common/ErroCarregamento';
import './Login.css';

export default function EsqueciSenha() {
  const [email, setEmail] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setEnviando(true);
    try {
      await esqueciSenha(email);
      setEnviado(true);
    } catch (err) {
      setErro(extrairMensagemErro(err, 'Não foi possível enviar o e-mail. Tente novamente.'));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="login-page">
      {/* ===== Painel esquerdo — marca ===== */}
      <div className="login-brand">
        <div className="login-brand__bars" aria-hidden="true">
          <i className="login-brand__bar login-brand__bar--1" />
          <i className="login-brand__bar login-brand__bar--2" />
          <i className="login-brand__bar login-brand__bar--3" />
        </div>

        <div className="login-brand__hero">
          <img src={logoPrimary} alt="AM Gestão" className="login-brand__logo" />
          <div className="login-brand__rule" />
          <p className="login-brand__text">
            Plataforma de gestão da jornada de acreditação hospitalar com base nos padrões da
            ONA.
          </p>
        </div>

        <div className="login-brand__footer">
          Desenvolvido por <strong>Datafit</strong>
        </div>
      </div>

      {/* ===== Painel direito — formulário ===== */}
      <div className="login-form-panel">
        <div className="login-form-inner">
          <div className="login-form__logo">
            <img src={logoHorizontal} alt="AM Gestão" />
          </div>

          <h1 className="login-form__title">Esqueceu a senha?</h1>

          {enviado ? (
            <>
              <p className="login-form__subtitle">
                Se esse e-mail estiver cadastrado, você vai receber um link de redefinição em
                instantes. Confira também a caixa de spam.
              </p>
              <Link to="/login" className="login-form__forgot" style={{ display: 'inline-block', marginTop: 20 }}>
                Voltar para o login
              </Link>
            </>
          ) : (
            <>
              <p className="login-form__subtitle">
                Informe seu e-mail cadastrado e enviaremos um link para você criar uma nova senha.
              </p>

              <form className="login-form__fields" onSubmit={handleSubmit}>
                <label className="am-field">
                  <div className="am-field__label-row">
                    <span className="am-field__label">E-mail</span>
                  </div>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="voce@instituicao.com.br"
                    autoComplete="username"
                    required
                  />
                </label>

                {erro && <div className="login-form__error">{erro}</div>}

                <button type="submit" className="am-btn-primary" disabled={enviando}>
                  <span className="ms">send</span>
                  {enviando ? 'ENVIANDO...' : 'ENVIAR LINK'}
                </button>

                <Link to="/login" className="login-form__forgot" style={{ textAlign: 'center', marginTop: 2 }}>
                  Voltar para o login
                </Link>
              </form>
            </>
          )}

          <div className="login-form__footer">ACF Moura · Consultoria ONA © 2026</div>
        </div>
      </div>
    </div>
  );
}
